"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var useStyles = function useStyles() {
  return {
    backdrop: {
      color: 'rgba(0, 0, 0, 0.54)',
      zIndex: 500
    }
  };
};

var _default = useStyles;
exports.default = _default;